import { BFF_API_ROUTES } from 'constants/apiRoutes';

import { baseRTKApi } from 'shared/api/baseApi';
import type { TGetVitrinsOffersRequest, TGetVitrinsOffersResponse } from 'shared/types/TVitrinsService';

export const vitrinsQueries = baseRTKApi.injectEndpoints({
  endpoints: (build) => ({
    getVitrins: build.query<TGetVitrinsOffersResponse, TGetVitrinsOffersRequest>({
      query: (body) => ({
        url: BFF_API_ROUTES.getVitrinsOffers,
        body,
        method: 'POST',
      }),
    }),
  }),
});

export const useGetVitrins = vitrinsQueries.useGetVitrinsQuery;
